<template>
    <transition
        name="fade"
        appear
    >
        <div v-show="showSurvey">
            <component
                :is="getSurveyComponent()"
                v-if="screenSize !== 'small'"
                :survey="survey"
                data-testid="survey"
                class="fixed bottom-0 right-0 max-h-[calc(100vh-120px)] bg-white rounded-lg mb-10 mr-10 p-6 md:w-120 md:shadow-xl z-50 overflow-y-auto"
                :context-id="contextId"
                :context-type="contextType"
                @show-survey="(e) => (showSurvey = e)"
            ></component>

            <portal
                v-if="screenSize === 'small'"
                to="overlays"
            >
                <div
                    v-if="showSurvey"
                    class="fixed top-0 z-50 block h-full w-screen"
                >
                    <div class="absolute bg-slate-400 opacity-15 w-full h-full"></div>
                    <component
                        :is="getSurveyComponent()"
                        :survey="survey"
                        class="absolute bottom-0 w-full bg-white p-6 max-h-screen overflow-y-scroll"
                        :context-id="contextId"
                        :context-type="contextType"
                        @show-survey="(e) => (showSurvey = e)"
                    ></component>
                </div>
            </portal>
        </div>
    </transition>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { retrieveSurvey } from '@/api/gateway/legacy-api/survey';

const surveyTemplates = {
    mood_scale: 'SurveyMoodScale',
};

export default {
    name: 'SurveyContainer',
    components: {
        // we can dynamically load other surveys to avoid having to import all of them when we will only ever want to show one
        SurveyMoodScale: defineAsyncComponent(() => import('@components/SurveyMoodScale')),
    },
    props: {
        contextId: {
            type: Number,
            default: null,
        },
        contextType: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            survey: null,
            showSurvey: false,
        };
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn', 'isVerified']),
        ...mapGetters('ui', ['screenSize']),
    },
    mounted() {
        if (this.isLoggedIn && this.isVerified) {
            this.getSurvey();
        }
    },
    methods: {
        getSurveyComponent() {
            return surveyTemplates[this.survey?.survey_type];
        },
        async getSurvey() {
            setTimeout(() => {
                retrieveSurvey(this.contextType, this.contextId).then((response) => {
                    if (response.status === 200) {
                        this.survey = response.data;
                        this.showSurvey = true;
                    }
                });
            }, 6000);
        },
    },
};
</script>
